/**
 * Convert a subset of Markdown (headings, bold/italic, lists, blockquotes,
 * inline code, horizontal rules) into HTML. Shared between the AI chat
 * bubble and the personal notes list so AI responses saved as notes render
 * identically to how they appeared in the chat.
 */
export function formatMarkdown(text: string): string {
  if (!text) return '';

  let html = text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');

  html = html.replace(/^### (.+)$/gm, '<h3>$1</h3>');
  html = html.replace(/^## (.+)$/gm, '<h2>$1</h2>');
  html = html.replace(/^# (.+)$/gm, '<h1>$1</h1>');

  html = html.replace(/^---+$/gm, '<hr>');

  html = html.replace(/\*\*\*(.+?)\*\*\*/g, '<strong><em>$1</em></strong>');
  html = html.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
  html = html.replace(/\*(.+?)\*/g, '<em>$1</em>');
  html = html.replace(/_(.+?)_/g, '<em>$1</em>');
  html = html.replace(/~~(.+?)~~/g, '<del>$1</del>');
  html = html.replace(/`([^`]+)`/g, '<code>$1</code>');

  html = html.replace(/^&gt; (.+)$/gm, '<blockquote>$1</blockquote>');
  html = html.replace(/<\/blockquote>\n<blockquote>/g, '\n');

  const lines = html.split('\n');
  const output: string[] = [];
  let inOl = false;
  let inUl = false;

  for (const line of lines) {
    const olMatch = line.match(/^(\d+)\.\s+(.+)$/);
    const ulMatch = line.match(/^[-*•]\s+(.+)$/);

    if (olMatch) {
      if (inUl) { output.push('</ul>'); inUl = false; }
      if (!inOl) { output.push('<ol>'); inOl = true; }
      output.push(`<li>${olMatch[2]}</li>`);
    } else if (ulMatch) {
      if (inOl) { output.push('</ol>'); inOl = false; }
      if (!inUl) { output.push('<ul>'); inUl = true; }
      output.push(`<li>${ulMatch[1]}</li>`);
    } else {
      if (inOl) { output.push('</ol>'); inOl = false; }
      if (inUl) { output.push('</ul>'); inUl = false; }
      if (line.trim() === '') {
        output.push('<br>');
      } else if (/^<(h[1-3]|hr|blockquote|ol|ul|li)/.test(line.trim())) {
        output.push(line);
      } else {
        output.push(`<p>${line}</p>`);
      }
    }
  }
  if (inOl) output.push('</ol>');
  if (inUl) output.push('</ul>');

  return output.join('');
}
